import React, { useEffect, useState } from "react";

import "./setting.scss";
import {
  Menu,
  Button,
  Card,
  Row,
  Col,
  Form,
  Select,
  Space,
  Modal,
  Input,
  Radio,
  Segmented,
  message,
} from "antd";
import { useTranslation } from "react-i18next";
import * as SignupService from "../../service/signupServices";
import * as localStorageService from "../../service/localStorageService";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import Notification from "../../service/notification";
import { CalendarOutlined, MailOutlined } from "@ant-design/icons";
import * as masterDataService from "../../service/masterDataService";
import * as lokalizeService from "../../service/lokalizeService";
import * as settingsService from "../../service/settingsService";
import { CommonConstants } from "../../constants/commonConstants";
import englishLang from "../../assets/images/english-lang.svg";
import hindiLang from "../../assets/images/hindi-lang.svg";
import arabicLang from "../../assets/images/arabic-lang.svg";
import urduLang from "../../assets/images/urdu-lang.svg";
import turkeyLang from "../../assets/images/turkey-lang.svg";
import russianLang from "../../assets/images/russian-lang.svg";
import preferencesIconTrukker from "../../assets/images/preferences-icon.svg";
import preferencesIconAdeed from "../../assets/adeed/images/preferences-icon.svg";
import changePinIconTrukker from "../../assets/images/change-pin-icon.svg";
import changePinIconAdeed from "../../assets/adeed/images/change-pin-icon.svg";
import boticonTrukker from "../../assets/images/bot-icon.svg";
import boticonAdeed from "../../assets/adeed/images/bot-icon.svg";
import languageIconTrukker from "../../assets/images/language-icon.svg";
import languageIconAdeed from "../../assets/adeed/images/language-icon.svg";
import logoutIconTrukker from "../../assets/images/logout-icon.svg";
import logoutIconAdeed from "../../assets/adeed/images/logout-icon.svg";
import appearanceIcon from "../../assets/images/appearance-icon.svg";

import { useNavigate } from "react-router-dom";
import { useStore } from "../../store/store";
import i18n from "../../util/i18n";

import UserPreferences from "./user-preference";
import { checkIsInternalSourcing } from "../../util/constantUtility";
import { saveAnalyticalData } from "../../util/analyticalUtility";
import * as accountService from "../../service/accountService";
import { brandText, isAdeed } from "../../constants/brand";
import { ThemeMode } from "../../constants/commonConstants";
import { setThemeMode, useThemeMode } from "../../common/theme-mode/theme-mode";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const preferencesIcon = isAdeed ? preferencesIconAdeed : preferencesIconTrukker;
const changePinIcon = isAdeed ? changePinIconAdeed : changePinIconTrukker;
const boticon = isAdeed ? boticonAdeed : boticonTrukker;
const languageIcon = isAdeed ? languageIconAdeed : languageIconTrukker;
const logoutIcon = isAdeed ? logoutIconAdeed : logoutIconTrukker;


const Setting = () => {
  const { t } = useTranslation();
  const { saveUser } = useStore();
  const {user} = useStore();
  const [changePinForm] = Form.useForm();
  const [languageForm] = Form.useForm();
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState("preferences");
  const [countriesListWaiter, setCountriesListWaiter] = useState(false);
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);
  const itemList = [
    {
      key: "preferences",
      icon: <img src={preferencesIcon} height={20} width={20} />,
      label: t("SETTINGS_PREFERENCES"),
    },
    {
      key: "changePin",
      icon: <img src={changePinIcon} height={20} width={20} />,
      label: t("SETTINGS_CHANGE_PIN"),
    },
    {
      key: "defaultLanguage",
      icon: <img src={boticon} height={20} width={20} />,
      label: t("SETTING_PREFRRED_LANG"),
    },
    {
      key: "language",
      icon: <img src={languageIcon} height={20} width={20} />,
      label: t("SETTINGS_LANGUAGE"),
    },
    // Light / dark / follow the device (ADEED only; src/common/theme-mode).
    isAdeed && {
      key: "appearance",
      icon: <img src={appearanceIcon} height={20} width={20} alt="" />,
      label: t("SETTINGS_APPEARANCE", { defaultValue: "Appearance" }),
    },
    !checkIsInternalSourcing(user?.userRole) &&  {
      key: "helpSupport",
      icon: <img src={languageIcon} height={20} width={20} />,
      label: t("SETTINGS_HELP_SUPPORT"),
    },
    {
      key: "logOut",
      icon: <img src={logoutIcon} height={20} width={20} />,
      label: t("SETTINGS_LOGOUT"),
    },
  ];
  const [projectLanguages, setProjectLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [oldPinValue, setOldPinValue] = useState("");
  const [isWaitLanguage, setIsWaitLanguage] = useState(false);
  const [changePinLoader, setChangePinLoader] = useState(false);
  const [preferredLanguages, setPreferredLanguages] = useState([]);
  const [preferredLanguage, setPreferredLanguage] = useState(null);
  const [savedPreferredLanguage, setSavedPreferredLanguage] = useState(null);
  const [savingPreferredLanguageLoader, setSavingPreferredLanguageLoader] = useState(false);
  const [languageLoader, setLanguageLoader] = useState(false);
  const themeMode = useThemeMode();

useEffect(() => {
    setUpProjectLanguage();
  }, []);

  useEffect(() => {
    if(selectedItem == 'defaultLanguage'){
      fetchPreferredLanguage();
    }
  }, [selectedItem]);

  const onCancelPin = () => {
    changePinForm.resetFields();
  };

  const onClickSection = (e) => {
    setPreferredLanguage(null);
    setSelectedItem(e.key);
    if (e.key == "logOut") {
      setIsLogOutModalOpen(true);
    }
    if (e.key == "helpSupport") {
      navigate("/helpAndSupport");
    }
  };

  const onClickLogOut = (value) => {
    try {
      // window.localStorage.clear();
      localStorageService.removeKey(LocalStorageKeys.AuthToken)
      localStorageService.removeKey(LocalStorageKeys.RefreshToken)
      localStorageService.removeKey(LocalStorageKeys.UniqueId)
      localStorageService.removeKey(LocalStorageKeys.UserDetails)
      saveUser(null);
      navigate("/login");
      saveAnalyticalData('LOGOUT','User logged out',user?.countryCode+' '+user?.mobileNo,user);
      // if (selectedLanguage !== CommonConstants.DefaultLanguageCode) {
      //   setUpLokalize(CommonConstants.DefaultLanguageCode);
      // }
      if (!value) {
        Notification.success(t("SUCCESS_KEY"),t("LOG_OUT_SUCCESS"));
      }
    } catch (error) {
      Notification.error("error", error.message);
    }
  };

  const setUpProjectLanguage = () => {
    lokalizeService
      .getAllLanguage()
      .then((res) => {
        setProjectLanguages(
          res.data.Data.map((item, index) => {
            return {
              key: item.LanguageISOCode,
              label: item.LanguageName,
              value: item.LanguageISOCode,
            };
          })
        );

        let lang = localStorageService.getValue(LocalStorageKeys.Lang);

        if (lang != null) {
          setSelectedLanguage(lang);
          languageForm.setFieldValue("language", lang);
        } else {
          setSelectedLanguage(CommonConstants.DefaultLanguageCode);
          languageForm.setFieldValue(
            "language",
            CommonConstants.DefaultLanguageCode
          );
        }
      })
      .catch((error) => {});
  };

  const handlePasswordChange = (field, value) => {
    // changePinForm.validateFields();
    setOldPinValue(value);
    changePinForm?.setFieldValue(field, value);
  };

const handlePreferredLanguageChange = (value) => {
  setPreferredLanguage(value);
};

const savePreferredLanguage = () => {
  if (!preferredLanguage) return;
  setSavingPreferredLanguageLoader(true);
  settingsService
    .updatePreferredLanguage({
      defaultLanguage: preferredLanguage,
    })
    .then(() => {
      setSavingPreferredLanguageLoader(false);
      Notification.success(
        t("SUCCESS_KEY"),
        t("Preferred language updated successfully")
      );
      getAccountDetails();
    })
    .catch(() => {
      Notification.error(
        t("ERROR_KEY"),
        t("Failed to update preferred language")
      );
      setSavingPreferredLanguageLoader(false);
    })
};

const cancelPreferredLanguage = () => {
  setPreferredLanguage("");
};


  const setUpLokalize = (selectedLang) => {
    setIsWaitLanguage(true);

    selectedLang = selectedLang
      ? selectedLang
      : localStorageService.getValue(LocalStorageKeys.Lang)
      ? localStorageService.getValue(LocalStorageKeys.Lang)
      : CommonConstants.DefaultLanguageCode;

    lokalizeService
      .getLanguagePack(selectedLang)
      .then((res) => {
        setIsWaitLanguage(false);

        let arr = res.data.Data;

        let LANGUAGE_KEYS = {};
        arr.forEach((ele) => {
          LANGUAGE_KEYS[ele.Key] = brandText(ele.Value);
        });

        i18n.addResources(selectedLang, "translations", LANGUAGE_KEYS);

        i18n.changeLanguage(selectedLang);
        localStorageService.setKey(LocalStorageKeys.Lang, selectedLang);
        let localUser={...user};
        localUser.selectedLanguage=selectedLang;
        saveUser(localUser);
      })
      .catch((error) => {
        setIsWaitLanguage(false);
        console.error(error);
      });
  };

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
    setUpLokalize(e.target.value);

  };

  const getImageByLang = (lang) => {
    switch (lang) {
      case "en":
        return englishLang;
      case "hi":
        return hindiLang;
      case "tr":
        return turkeyLang;
      case "ru":
        return russianLang;
      case "fr":
        return russianLang;
      case "ar":
        return arabicLang;
      case "pl_PL":
        return urduLang;
      default:
        return englishLang;
    }
  };

  const savePinDetails = () => {
    changePinForm
      .validateFields()
      .then(() => {
        if (
          changePinForm.getFieldValue("oldPin") &&
          changePinForm.getFieldValue("createPin")
        ) {
          if (
            changePinForm.getFieldValue("createPin") !==
            changePinForm.getFieldValue("confirmPin")
          ) {
            return Notification.error(t("ERROR_KEY"), t("PIN_NOT_MATCH_ERROR"));
          }

          let payload = {
            oldPin: changePinForm.getFieldValue("oldPin"),
            newPin: changePinForm.getFieldValue("createPin"),
          };

          setChangePinLoader(true);
          settingsService
            .changePinDetails(payload)
            .then((response) => {
              setChangePinLoader(false);
              if (response.status === 200) {
                Notification.success(t("SUCCESS_KEY"),
                  t("PIN_CHANGE_SUCCESS")
                );
                onClickLogOut(true);
                changePinForm.resetFields();
              } else {
                Notification.error("error", response.data.message);
              }
            })
            .catch((error) => {
              setChangePinLoader(false);
            });
        }
      })
      .catch(() => {
        setChangePinLoader(false);
        console.log("All fields are not entered for changing Pin in settings");
      });
  };
const fetchPreferredLanguage = () => {
  settingsService.getLanguageMaster()
    .then((res) => {
      const languages = res?.data || []; // ARRAY OF STRINGS
      const languageOptions = languages?.map(lang => ({
                  label: lang,
                  value: lang,
                }));
      setPreferredLanguages(languageOptions);
      getAccountDetails();
    })
    .catch((err) => console.error(err));
};

 const getAccountDetails = () => {
      setLanguageLoader(true);
    accountService
      .getAccountDetails(user?.userId)
      .then((response) => {
        setLanguageLoader(false);
        if(response?.data.status){
          let result = response?.data?.data;
        if (result) {
        setPreferredLanguage(result.defaultLanguage ? result.defaultLanguage:"");
        setSavedPreferredLanguage(result.defaultLanguage ? result.defaultLanguage:"");
        }
        }
      })
      .catch((error) => {
        setLanguageLoader(false);
      });
  };

  const allowOnlyNumbers = (event) => {
    if (!/[0-9]/.test(event?.key)) {
      event.preventDefault();
    }
  };

  return (
    <div className="setting-wrapper">
      <Row>
        <Col>
          <Card style={{ width: "350px",marginTop:'12px'  }}>
            <Menu
              style={{
                width: 256,
              }}
              selectedKeys={[selectedItem]}
              items={itemList}
              onClick={onClickSection}
            />
          </Card>
        </Col>
        <Col span={16} style={{ paddingLeft: "20px", marginTop:'12px' }}>
          <Card >
            {selectedItem == "preferences" && (
              <UserPreferences></UserPreferences>
            )}
            {selectedItem == "changePin" && (
              <div>
                <b>{t("SETTINGS_CHANGE_PIN")}</b>
                <hr />
                <div style={{ margin: "2rem" }}>
                  <Form
                    form={changePinForm}
                    name="changePinForm"
                    layout={"vertical"}
                  >
                    <Row>
                      <Form.Item>
                        <Col>
                          <Form.Item
                            rules={[
                              { required: true, message: t("PIN_REQUIRED")},
                            ]}
                            name="oldPin"
                            className="floating-label-form-item"
                          >
                            <Input.Password
                              minLength={6}
                              maxLength={6}
                              placeholder={t("SETTINGS_OLD_PIN_PH")}
                              onKeyPress={allowOnlyNumbers}
                              className="floating-input-basic"
                              onChange={(e) =>
                                handlePasswordChange("oldPin", e.target.value)
                              }
                            />
                            <label className="floating-label">
                              {t("SETTINGS_OLD_PIN")} *
                            </label>
                          </Form.Item>
                          {/* <div style={{ textAlign: "end", marginTop: "0.5rem" }}><a>Forgot PIN?</a></div> */}
                        </Col>
                      </Form.Item>
                    </Row>
                    <Row>
                      <Form.Item>
                        <Col>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t("NEW_PIN_REQUIRED"),
                              },
                            ]}
                            name="createPin"
                            className="floating-label-form-item"
                          >
                            <Input.Password
                              minLength={6}
                              maxLength={6}
                              placeholder={t("SETTINGS_NEW_PIN_PH")}
                              onKeyPress={allowOnlyNumbers}
                              className="floating-input-basic"
                              onChange={(e) =>
                                handlePasswordChange(
                                  "createPin",
                                  e.target.value
                                )
                              }
                            />
                            <label className="floating-label">
                              {t("SETTINGS_ENTER_NEW_PIN")} *
                            </label>
                          </Form.Item>
                        </Col>
                      </Form.Item>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Item
                          rules={[
                            { required: true, message: t("RE_PIN_REQUIRED")},
                          ]}
                          name="confirmPin"
                          className="floating-label-form-item"
                        >
                          <Input.Password
                            minLength={6}
                            maxLength={6}
                            placeholder={t("SETTINGS_RE_ENTER_PIN_PH")}
                            onKeyPress={allowOnlyNumbers}
                            className="floating-input-basic"
                            onChange={(e) =>
                              handlePasswordChange("confirmPin", e.target.value)
                            }
                          />
                          <label className="floating-label">
                            {t("SETTINGS_RE_ENTER_PIN")} *
                          </label>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify={"start"} style={{ marginLeft: "11rem" }}>
                      <Space size="middle" className="button-space">
                        <Button
                          onClick={onCancelPin}
                          loading={changePinLoader}
                          className="cancel-btn"
                        >
                          {t("COMMON_CANCEL_BTN")}
                        </Button>
                        <Button
                          htmlType="submit"
                          loading={changePinLoader}
                          className="submit-btn"
                          onClick={savePinDetails}
                        >
                          {t("COMMON_SAVE_BTN")}
                        </Button>
                      </Space>
                    </Row>
                  </Form>
                </div>
              </div>
            )}
            {selectedItem === "defaultLanguage" && (
              <div>
                <b>{t("Preferred Language")}</b>
                <hr />

                <div style={{ maxWidth: 400, marginTop: "1.5rem" }}>
                  <Form layout="vertical">
                    <Form.Item
                      label={t("SETTING_SET_PREFERRENCE_LANG")}
                    >
                      <Select
                        placeholder={t("Select Language")}
                        value={preferredLanguage}
                        onChange={handlePreferredLanguageChange}
                        loading={!preferredLanguages.length || languageLoader}
                        size="large"
                        options={preferredLanguages}
                        disabled={savingPreferredLanguageLoader || languageLoader}
                      >
                      </Select>
                    </Form.Item>

                    <Space style={{marginTop:'5rem',marginLeft:"15rem"}}>
                      <Button
                        onClick={cancelPreferredLanguage}
                        disabled={savingPreferredLanguageLoader || !preferredLanguages.length || languageLoader}
                        size="large"
                      >
                        {t("SETTING_CLEAR")}
                      </Button>
                      <Button
                        type="primary"
                        loading={savingPreferredLanguageLoader}
                        onClick={savePreferredLanguage}
                        disabled={(preferredLanguage === savedPreferredLanguage) || !preferredLanguage || savingPreferredLanguageLoader || !preferredLanguages.length || languageLoader}
                        size="large"
                      >
                        {t("COMMON_SAVE_BTN")}
                      </Button>
                    </Space>
                  </Form>
                </div>
              </div>
            )}


            {selectedItem == "language" && (
              <>
                {" "}
                <div>
                  <b>{t("SETTINGS_LANGUAGE")}</b>
                  <hr />
                  <div className="language-card">
                    <Form form={languageForm} layout={"vertical"}>
                      <Form.Item name="language">
                        {/* {selectedLanguage} */}
                        <Radio.Group
                          onChange={handleLanguageChange}
                          value={selectedLanguage}
                          style={{ width: "100%" }}
                        >
                          {projectLanguages?.map((item, index) => {
                            return (
                              <div
                                style={{ margin: "1.5rem 0", height: "60px" }}
                              >
                                <Radio value={item?.value} >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    
                                      justifyContent:'space-between'
                                    }}
                                  >
                                    <div>{item?.label}</div>
                                    <div className={selectedLanguage === "ar"?"radioright":"radioLeft"}>
                                      <img
                                        src={getImageByLang(item?.value)}
                                        alt="alt"
                                        height={50}
                                        width={180}
                                      />
                                    </div>
                                  </div>
                                </Radio>
                              </div>
                            );
                          })}
                        </Radio.Group>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
                {/* <Row justify={'end'} style={{marginTop:"3rem"}}>
             <Space size="middle" className="button-space">
             <Button size="middle" className="submit-btn">
             {t("COMMON_SAVE_BTN")}
             </Button>
             </Space>
             </Row> */}
              </>
            )}

            {isAdeed && selectedItem === "appearance" && (
              <div className="appearance-setting">
                <b>{t("SETTINGS_SET_APPEARANCE", { defaultValue: "Set Appearance" })}</b>
                <hr />
                <div className="appearance-setting__body">
                  <span className="appearance-setting__hint">
                    {t("SETTINGS_APPEARANCE_HINT", {
                      defaultValue: "Light or dark. System follows this device. Remembered on this device.",
                    })}
                  </span>
                  <Segmented
                    size="large"
                    value={themeMode}
                    onChange={setThemeMode}
                    options={[
                      { value: ThemeMode.LIGHT, label: t("SETTINGS_APPEARANCE_LIGHT", { defaultValue: "Light" }) },
                      { value: ThemeMode.DARK, label: t("SETTINGS_APPEARANCE_DARK", { defaultValue: "Dark" }) },
                      { value: ThemeMode.SYSTEM, label: t("SETTINGS_APPEARANCE_SYSTEM", { defaultValue: "System" }) },
                    ]}
                  />
                </div>
              </div>
            )}

            {selectedItem == "logOut" && (
              <Modal
                className="logoutmodal"
                open={isLogOutModalOpen}
                centered="true"
                footer={false}
                onCancel={() => {
                  setIsLogOutModalOpen(false);
                  setSelectedItem("preferences");
                }}
              >
                <div className="logout-content">
                  <span className="logout-title">
                    {t("SETTINGS_LOGGING_OUT")}
                  </span>
                  {/* <hr class="line"></hr> */}
                  <span className="logout-msg">
                    {t("SETTINGS_LOGOUT_MSG")} ?{" "}
                  </span>
                  <span className="logout-btn">
                    <Button type="secondary"
                      className="submit-btn"
                      onClick={() => onClickLogOut(false)}
                    >
                      {t("COMMON_YES_BTN")}
                    </Button>
                    <Button
                      className="cancel-btn"
                      onClick={() => {
                        setIsLogOutModalOpen(false);
                        setSelectedItem("preferences");
                      }}
                    >
                      {t("COMMON_NO_BTN")}
                    </Button>
                  </span>
                </div>
              </Modal>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Setting;
